var PI = 3.14159265358979324

function transformLat(x, y) {
  var ret = -100.0 + 2.0 * x + 3.0 * y + 0.2 * y * y + 0.1 * x * y + 0.2 * Math.sqrt(Math.abs(x))
  ret += (20.0 * Math.sin(6.0 * x * PI) + 20.0 * Math.sin(2.0 * x * PI)) * 2.0 / 3.0
  ret += (20.0 * Math.sin(y * PI) + 40.0 * Math.sin(y / 3.0 * PI)) * 2.0 / 3.0
  ret += (160.0 * Math.sin(y / 12.0 * PI) + 320 * Math.sin(y * PI / 30.0)) * 2.0 / 3.0
  return ret
}

function transformLon(x, y) {
  var ret = 300.0 + x + 2.0 * y + 0.1 * x * x + 0.1 * x * y + 0.1 * Math.sqrt(Math.abs(x))
  ret += (20.0 * Math.sin(6.0 * x * PI) + 20.0 * Math.sin(2.0 * x * PI)) * 2.0 / 3.0
  ret += (20.0 * Math.sin(x * PI) + 40.0 * Math.sin(x / 3.0 * PI)) * 2.0 / 3.0
  ret += (150.0 * Math.sin(x / 12.0 * PI) + 300.0 * Math.sin(x / 30.0 * PI)) * 2.0 / 3.0
  return ret
}

function delta(lat, lon) {
  var a = 6378245.0
  var ee = 0.00669342162296594323
  var dLat = transformLat(lon - 105.0, lat - 35.0)
  var dLon = transformLon(lon - 105.0, lat - 35.0)
  var radLat = lat / 180.0 * PI
  var magic = Math.sin(radLat)
  magic = 1 - ee * magic * magic
  var sqrtMagic = Math.sqrt(magic)
  dLat = (dLat * 180.0) / ((a * (1 - ee)) / (magic * sqrtMagic) * PI)
  dLon = (dLon * 180.0) / (a / sqrtMagic * Math.cos(radLat) * PI)
  return { lat: dLat, lon: dLon }
}

/**
 * BD-09 -> GCJ-02（火星坐标系）
 * 适用于高德地图
 */
export function bd09ToGcj02(bd_lon, bd_lat) {
  var x_pi = PI * 3000.0 / 180.0
  var x = bd_lon - 0.0065
  var y = bd_lat - 0.006
  var z = Math.sqrt(x * x + y * y) - 0.00002 * Math.sin(y * x_pi)
  var theta = Math.atan2(y, x) - 0.000003 * Math.cos(x * x_pi)
  return [z * Math.cos(theta), z * Math.sin(theta)]
}

/**
 * WGS-84 -> GCJ-02（火星坐标系）
 */
export function wgs84ToGcj02(lon, lat) {
  var d = delta(lat, lon)
  return {
    lon: Number((lon + d.lon).toFixed(5)),
    lat: Number((lat + d.lat).toFixed(5))
  }
}

/**
 * BD-09 -> WGS-84
 * 适用于天地图
 */
export function bd09ToWgs84(lon, lat) {
  var x_pi = PI * 3000.0 / 180.0
  var x = lon - 0.0065
  var y = lat - 0.006
  var z = Math.sqrt(x * x + y * y) - 0.00002 * Math.sin(y * x_pi)
  var theta = Math.atan2(y, x) - 0.000003 * Math.cos(x * x_pi)
  var gcjLat = z * Math.sin(theta)
  var gcjLon = z * Math.cos(theta)
  var d = delta(gcjLat, gcjLon)
  return {
    lon: Number((gcjLon - d.lon).toFixed(5)),
    lat: Number((gcjLat - d.lat).toFixed(5))
  }
}
